import React from "react";
import Line from "../../../assets/line2.svg";
import { FaStar } from "react-icons/fa";
// import cardimg from "../../../assets/ST.png";
import cardimg from "../../../assets/new/bgimg.jpeg";

export default function Sample() {
  return (
    <div
      className="min-h-[75vh] mb-[22px] min-[370px]:mb-[19px] min-[400px]:mb-[14px] min-[768px]:mb-[13px] lg:mb-[0px] min-[640px]:mb-[11px] flex justify-center items-center px-5 relative"
      style={{
        backgroundImage: `url(${cardimg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
      }}
    >
      <div className="absolute inset-0 bg-[#777f90] opacity-60 z-0"></div>
      <div className="flex flex-col justify-center items-center flex-1 mt-5 relative z-10 w-full text-white text-center">
        <div className="flex justify-center items-center mb-4">
          {[...Array(5)].map((_, i) => (
            <span key={i} className="text-[#4f7fff] text-3xl mr-1">
              <FaStar />
            </span>
          ))}
        </div>
        <h2 className="text-3xl px-4 sm:px-28 lg:px-72 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold leading-tight">
          Our{" "}
          <span className="relative inline-block">
            Support Team
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-8 min-[500px]:top-9 lg:top-[44px]"
            />
          </span>{" "}
          Is Here for You
        </h2>
        <p className="text-xl md:text-[22px] mt-4 py-4 lg:px-28">
          Meet our friendly support team. They are fast, smart, friendly, and
          love what they do!
        </p>
      </div>
    </div>
  );
}
